"use client";

import React from "react";
import { useTranslations } from "next-intl";
import { Translations } from "@/translations";

const IntroCard: React.FC = () => {
  const homeT = useTranslations("Homepage");
  const claimT = useTranslations("EducationClaim");

  return (
    <section
      style={{
        background: "linear-gradient(130deg, #f6fbff 0%, #ecf6ee 100%)",
        border: "1px solid #dbe9dc",
        borderRadius: "20px",
        padding: "32px",
        marginBottom: "24px",
      }}
    >
      <p style={{ marginBottom: "8px", color: "#1e5f39", fontWeight: 600 }}>
        {homeT(Translations.Homepage.DiscoveryEyebrow)}
      </p>
      <h2 style={{ color: "#143248", marginBottom: "14px" }}>
        {homeT(Translations.Homepage.DiscoveryTitle)}
      </h2>
      <p style={{ color: "#4a6171", maxWidth: "760px", marginBottom: "8px" }}>
        {homeT(Translations.Homepage.DiscoveryDescription)}
      </p>
      <p style={{ color: "#617989", marginBottom: "20px" }}>
        {homeT(Translations.Homepage.DiscoveryFreeHint)}
      </p>

      <div className="row g-3">
        <div className="col-lg-6">
          <div
            style={{
              background: "#ffffff",
              border: "1px solid #d7e5ef",
              borderRadius: "14px",
              padding: "16px",
              height: "100%",
            }}
          >
            <h3 style={{ fontSize: "1.05rem", color: "#143248", marginBottom: "10px" }}>
              {claimT("ClaimBenefitsFaqDirectoriesQuestion")}
            </h3>
            <p style={{ color: "#4a6171", margin: 0 }}>
              {claimT("ClaimBenefitsFaqDirectoriesAnswer")}
            </p>
          </div>
        </div>

        <div className="col-lg-6">
          <div
            style={{
              background: "#ffffff",
              border: "1px solid #d7e5ef",
              borderRadius: "14px",
              padding: "16px",
              height: "100%",
            }}
          >
            <h3 style={{ fontSize: "1.05rem", color: "#143248", marginBottom: "10px" }}>
              {claimT("ClaimBenefitsFaqMapsQuestion")}
            </h3>
            <p style={{ color: "#4a6171", margin: 0 }}>
              {claimT("ClaimBenefitsFaqMapsAnswer")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroCard;
